import React from "react";
import { motion } from "framer-motion"; // Animation ke liye: npm install framer-motion
import Choose from "../../../assets/image/choose-1.jpg";
import Bgchose from "../../../assets/image/pattern-3.png";
import { FaBriefcase, FaBalanceScale, FaFileAlt, FaComments } from "react-icons/fa";

const features = [
    {
        title: "Professional Coordination & Organized Processing",
        desc: "We simplify complex procedures by providing structured administrative support and clear guidance throughout your file preparation process.",
        icon: <FaBriefcase />,
    },
    {
        title: "Access to Licensed Legal Professionals",
        desc: "We connect clients with independently licensed and experienced lawyers for legal advice and representation. All legal services are provided by authorized professionals.",
        icon: <FaBalanceScale />,
    },
    {
        title: "Document Preparation & File Support",
        desc: "We assist clients in understanding, collecting, and organizing required documents to ensure their files are complete and properly prepared before submission.",
        icon: <FaFileAlt />,
    },
    {
        title: "Transparent & Reliable Support",
        desc: "We maintain clear communication between clients and legal professionals to ensure smooth coordination at every stage.",
        icon: <FaComments />,
    },
];

const Benefits = () => {
    return (
        <section
            className="relative py-16 lg:py-24 bg-[#f8fafc] overflow-hidden"
            style={{
                backgroundImage: `url(${Bgchose})`,
                backgroundSize: '400px', // Pattern ko subtle rakhne ke liye
                backgroundRepeat: 'repeat'
            }}
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

                    {/* LEFT CONTENT */}
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: true }}
                    >
                        <span className="inline-block px-4 py-1 rounded-full bg-red-50 text-[#ec4e4f] text-sm font-bold tracking-widest uppercase mb-4">
                            WHY CHOOSE TRINITY
                        </span>

                        {/* <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 leading-tight mb-6">
                            Simplifying Your Journey With <span className="text-[#ec4e4f]">Expertise.</span>
                        </h2> */}

                        {/* <p className="text-lg text-slate-600 mb-10 leading-relaxed">
                            Immigration procedures can be complex. Trinity provides the structure
                            and coordination you need to move forward with peace of mind.
                        </p> */}

                        {/* FEATURES GRID */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-6">
                            {features.map((feature, index) => (
                                <motion.div
                                    key={index}
                                    whileHover={{ translateY: -5 }}
                                    className="group flex items-start gap-5 p-4 rounded-xl transition-all duration-300 hover:bg-white hover:shadow-xl hover:shadow-slate-200/60"
                                >
                                    <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center bg-white shadow-sm rounded-2xl text-[#ec4e4f] text-2xl group-hover:bg-[#ec4e4f] group-hover:text-white transition-colors duration-300">
                                        {feature.icon}
                                    </div>
                                    <div>
                                        <h4 className="text-xl text-slate-800 font-bold mb-1">
                                            {feature.title}
                                        </h4>
                                        <p className="text-sm text-slate-500 leading-relaxed">
                                            {feature.desc}
                                        </p>
                                    </div>
                                </motion.div>
                            ))}
                        </div>

                        {/* DISCLAIMER */}
                        <div className="mt-10 p-4 border-l-4 border-slate-300 bg-slate-100/50 rounded-r-lg">
                            <p className="text-xs text-slate-500 italic">
                                <strong>Disclaimer:</strong> Trinity Management Services provides administrative and coordination support only. We are not a law firm and do not provide legal advice. Legal services are provided by independently licensed professionals.
                            </p>
                        </div>
                    </motion.div>

                    {/* RIGHT IMAGE WITH DECORATION */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: true }}
                        className="relative"
                    >
                        {/* Decorative Box behind image */}
                        <div className="absolute -top-6 -right-6 w-full h-full border-2 border-[#ec4e4f] rounded-2xl hidden md:block"></div>

                        <div className="relative overflow-hidden rounded-2xl shadow-2xl">
                            <img
                                src={Choose}
                                alt="Why Choose Trinity"
                                className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-700"
                            />
                        </div>

                        {/* Stats Overlay (Optional) */}
                        <div className="absolute -bottom-8 -left-8 bg-white p-6 rounded-2xl shadow-xl hidden xl:block">
                            <p className="text-4xl font-bold text-[#ec4e4f]">100%</p>
                            <p className="text-sm font-semibold text-slate-700 uppercase tracking-wider">Reliable Support</p>
                        </div>
                    </motion.div>

                </div>
            </div>
        </section>
    );
};

export default Benefits;